
import { defineComponent } from 'vue'
import Text from './common/Text.vue'
import { getHomeScreen } from '@/scripts/root/homeScreens'

export default defineComponent({
  components: {
    Text,
  },
  computed: {
    currentLanguage(): string {
      return this.$store.getters.getAppLanguage
    },
    previewImage(): string {
      return getHomeScreen(this.currentLanguage, 4)
    },
    formattedHeader() {
      return this.$t('home.mealInput.header').replace(/\n/g, '<br>')
    },
    formattedDesc() {
      return this.$t('home.mealInput.desc').replace(/\n/g, '<br>')
    },
  },
})
